import { CategorySlug } from './config';
import { generatePath } from 'react-router-dom';

interface HomeBuildParams {
  searchParams?: URLSearchParams;
}

interface CategoryBuildParams {
  slug: string;
  page?: number;
  searchParams?: URLSearchParams;
}

interface SearchBuildParams {
  criteria: string;
  page?: number;
  searchParams?: URLSearchParams;
}

const clearSearchParams = (searchParams: URLSearchParams) => {
  searchParams.delete('criteria');
  searchParams.delete('page');
};

export const appRoutes = {
  home: {
    build: ({ searchParams: urlSearchParams }: HomeBuildParams) => {
      const searchParams = new URLSearchParams(urlSearchParams);
      clearSearchParams(searchParams);
      const search = searchParams.toString()
        ? `?${searchParams.toString()}`
        : '';
      return `/?${search}`;
    },
  },
  category: {
    pattern: '/:categorySlug?/:page?',
    build: ({
      searchParams: urlSearchParams,
      page,
      slug: categorySlug,
    }: CategoryBuildParams) => {
      const isValidPage = page && Number.isInteger(page) && page > 1;
      const pathParams = {
        page: isValidPage ? page : undefined,
        categorySlug:
          !categorySlug ||
          (!isValidPage && categorySlug === CategorySlug.DEFAULT)
            ? ''
            : categorySlug,
      };

      const searchParams = new URLSearchParams(urlSearchParams);
      clearSearchParams(searchParams);
      const search = searchParams.toString()
        ? `?${searchParams.toString()}`
        : '';

      const path = generatePath(appRoutes.category.pattern, pathParams);

      return `${path}${search}`;
    },
  },
  search: {
    build: ({
      searchParams: urlSearchParams,
      criteria,
      page,
    }: SearchBuildParams) => {
      const searchParams = new URLSearchParams(urlSearchParams);
      searchParams.set('criteria', criteria);
      if (page && Number.isInteger(page) && page > 1) {
        searchParams.set('page', page.toString());
      } else {
        searchParams.delete('page');
      }

      return `/?${searchParams?.toString()}`;
    },
  },
};
